export default "__VITE_PUBLIC_ASSET__6c249193__"